import { getDemoSearchResults } from './searchResults';
export const getDemoSuggestionsContent = (demoDocumentTypes) => {
    return demoDocumentTypes.map((documentType) => {
        const documents = getDemoSearchResults({
            documentType,
            skip: 0,
            limit: 4,
            query: '',
            useRawProductDocuments: true,
            modalSuggestionsDocuments: true,
        });
        return {
            documentType,
            documents,
        };
    });
};
//# sourceMappingURL=suggestionsResults.js.map